import { TextInputProps } from 'react-admin';
import { TextInput } from './RA';

export const PhoneInput = (props: TextInputProps) => (
  <TextInput {...props} />
);
